module.exports = __webpack_public_path__ + "static/media/ActiveBreak.c106f85f.png";